import { render, staticRenderFns } from "./Claims.vue?vue&type=template&id=0e0c9d58&"
import script from "./Claims.vue?vue&type=script&lang=ts&"
export * from "./Claims.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports